import { Map } from 'immutable';
import reducerChain from '../helpers/chain';
import Constants from '../../constants/index';
import { QuestionRecord } from '../../records/index';
import {
	reducerMerger,
	reducerRemover,
	reducerUpdateVoteCountInContent,
	reducerUpdateWatching,
} from '../helpers/entities';
import { parseActionTypeAndState, actionPredicate } from '../helpers';

export const DEFAULT_STATE = Map({});

export const reducerAcceptAnswer =
	(acceptedActions) =>
	(state = Map(), dispatchedAction) => {
		const action = parseActionTypeAndState(dispatchedAction);

		if (actionPredicate(action.actionType, acceptedActions)) {
			if (action.succeeded) {
				const question = state.get(action.params.questionId);
				const modifiedQuestion = question.set('acceptedAnswer', action.params.answerId);
				return state.set(action.params.questionId, modifiedQuestion);
			}
			return state;
		}
		return state;
	};

export const reducerUnAcceptAnswer =
	(acceptedActions) =>
	(state = Map(), dispatchedAction) => {
		const action = parseActionTypeAndState(dispatchedAction);

		if (actionPredicate(action.actionType, acceptedActions)) {
			if (action.succeeded) {
				const question = state.get(action.params.questionId);
				const modifiedQuestion = question.set('acceptedAnswer', null);
				return state.set(action.params.questionId, modifiedQuestion);
			}
			return state;
		}
		return state;
	};

const questionsDefault = reducerMerger(
	[
		Constants.FETCH_QUESTION_LIST,
		Constants.FETCH_QUESTION,
		Constants.FETCH_QUESTION_RELATED,
		Constants.SEARCH_QUESTIONS,
	],
	'questions',
	QuestionRecord,
);
const questionsWithVotes = reducerUpdateVoteCountInContent([
	Constants.VOTE_UP,
	Constants.VOTE_DOWN,
]);
const questionsWithAcceptedAnswer = reducerAcceptAnswer([Constants.ACCEPT_ANSWER]);
const questionsWithUnacceptedAnswer = reducerUnAcceptAnswer([Constants.UNACCEPT_ANSWER]);
const questionsWithDelete = reducerRemover(Constants.DELETE_QUESTION);
const questionsWithWatching = reducerUpdateWatching([
	Constants.IS_WATCHING_QUESTION,
	Constants.WATCH_QUESTION,
	Constants.UNWATCH_QUESTION,
]);

export default reducerChain(
	[
		questionsDefault,
		questionsWithVotes,
		questionsWithAcceptedAnswer,
		questionsWithUnacceptedAnswer,
		questionsWithWatching,
		questionsWithDelete,
	],
	DEFAULT_STATE,
);
